module.exports = __webpack_public_path__ + "media/images/thumb_avatar-86f63f822e5f3ff1e893d7dc1cf90988.png";